import { Link } from '@delmonicos/shared-design-system-react/src/components/link/link';
import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { InvoiceModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/invoices-service-lib/src/wrapper/outputs/invoice.model';
import { CellContext } from '@tanstack/react-table';
import { generatePath, useNavigate } from 'react-router-dom';

import { APP_PATH } from '@app/config/app-paths';

export interface InvoiceListNetworkCellProps
  extends CellContext<InvoiceModel, InvoiceModel['network']> {}

export const InvoiceListNetworkCell = (
  props: InvoiceListNetworkCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { getValue } = props;
  const navigate = useNavigate();

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Link
      onClick={() =>
        navigate(
          generatePath(APP_PATH.NETWORK.DETAILS, {
            id: getValue()?.id,
          }),
        )
      }>
      <Text truncate>{getValue()?.name}</Text>
    </Link>
  );
};
